import HttpRequest from "./http_request";

class AuthProvider extends HttpRequest {
  async login(data) {
    return this.create("/auth/login", data);
  }
}

export default AuthProvider;
